<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <div class="pdf-question-container">
    <h3 *ngIf="!pdfUrl">Do you want to generate a PDF version for this dictionary?</h3>
    <div class="dictionary-title" *ngIf="!pdfUrl">{{ dictionary()?.title || 'Dictionary' }}</div>
    <div class="pdf-actions" *ngIf="!pdfUrl">
      <button mat-button style="border-radius: 10px" type="button" [disabled]="loading" (click)="onCancel()">
        Cancel
      </button>
      <ddc-button-s-one
        *ngIf="!pdfUrl && !error"
        [_isLoading]="loading"
        [_label]="loading ? 'Generating...' : 'Generate'"
        [disabled]="loading"
        (click)="onGeneratePdf()"
      ></ddc-button-s-one>
    </div>
    <div class="pdf-error" *ngIf="error">{{ error }}</div>
    <div class="pdf-success" *ngIf="pdfUrl">{{ pdfUrl }}</div>
    <ddc-button-r-one
      *ngIf="pdfUrl"
      [dynamicRoute]="'/library/12'"
      [icon]="'print'"
      [label]="'Go to Library'"
      [type]="'route'"
      (click)="onCancel()"
    >
    </ddc-button-r-one>
  </div>
</div>
